<template>

	<v-form ref="form">
		<v-toolbar color="#1f97b9" dark>
			<img :src='require("../../../assets/static/img/datos-generales.png")'  style="width: 30px;margin-right:16px;">
			<v-toolbar-title>Datos Generales</v-toolbar-title>
		</v-toolbar>

			<v-layout row wrap ma-3>
				<v-flex md4 sm4 xs12 px-3>
					<v-text-field
						id="test-0"
						v-model="datos.personales.nombre"
						label="Nombre y apellido"
						color="#1f97b9"
						:rules="rules.nameRules"
						required
					>
						<img :src='require("../../../assets/static/img/nombre-apellido.png")' alt="datos personales" style="width: 25px;height:25px;" slot="prepend">
					</v-text-field>

				</v-flex>
				<v-flex md4 sm4 xs12 px-3>

					<v-text-field
						id="test-1"
						v-model="datos.personales.telefono"
						label="Teléfono"
						color="#1f97b9"
						:rules="rules.phoneRules"
						required
					>
						<img :src='require("../../../assets/static/img/telefono.png")' alt="icono de telefono" style="width: 25px;height:25px;" slot="prepend">
					</v-text-field>

				</v-flex>
				<v-flex md4 sm4 xs12 px-3>

					<v-text-field
						id="test-2"
						v-model="datos.personales.email"
						label="Email"
						color="#1f97b9"
						:rules="rules.emailRules"
						required
					>
						<img :src='require("../../../assets/static/img/email.png")' alt="icono de email" style="width: 25px;height:25px;" slot="prepend">
					</v-text-field>

				</v-flex>

				<v-flex md4 sm4 xs12 px-3>
					<v-menu
						ref="menuDate"
						:close-on-content-click="true"
						v-model="menu"
						:nudge-right="40"
						lazy
						transition="scale-transition"
						offset-y
						full-width
						min-width="290px"
						class="mb-5"
					>
						<v-text-field
							slot="activator"
							v-model="datos.first.date"
							label="Seleccione Fecha"
							color="#1f97b9"
							readonly
							:rules="rules.nameRules"
						>
							<img :src='require("../../../assets/static/img/fecha.png")' alt="icono de fecha" style="width: 25px;height:25px;" slot="prepend">
						</v-text-field>
						<v-date-picker
							v-model="datos.first.date"
							:min="today"
							no-title
							scrollable
							prev-icon="fas fa-chevron-left caption"
							next-icon="fas fa-chevron-right caption"
							locale="es-mx"
							first-day-of-week="1"
						>
							<v-spacer></v-spacer>
							<v-btn flat color="primary" @click="menu = false">Cancelar</v-btn>
						</v-date-picker>
					</v-menu>

					<v-progress-linear v-show="!mantenedores.tiempo_minimo" :indeterminate="true" color="#1f97b9"></v-progress-linear>
					<div v-show="mantenedores.tiempo_minimo" class="flex-hour-container v-input v-text-field v-input--is-label-active v-input--is-dirty v-input--is-readonly theme--light">
						<div class="v-input__prepend-outer">
							<img :src='require("../../../assets/static/img/hora.png")' alt="imagen de horario" style="width: 25px;height:25px;">
						</div>
						<div class="hour-picker-container">
							<v-select
								v-model="datos.first.time"
			          :items="horas"
								@input="validTimeDiff"
								:rules="rules.nameRules"
								append-icon="fas fa-caret-down"
			          label="Seleccione Hora"
			        ></v-select>
						</div>
						<v-tooltip right v-model="showTooltip" max-width="350px" :color="typeTooltip == 'warning' ? '#616161' : 'red'">
			        <v-icon slot="activator" :color="colorTooltipActivator" small class="ml-2">fas fa-exclamation-triangle</v-icon>
			        <span v-if="typeTooltip == 'warning'">Si necesitas el servicio antes de 3 horas, no te preocupes, llámanos al +569 6590 9598 y lo resolvemos.</span>
			        <span v-else>Recuerda, si necesitas el servicio antes de 3 horas, no te preocupes, llámanos al +569 6590 9598 y lo resolvemos.</span>
				    </v-tooltip>
					</div>
				</v-flex>

			</v-layout>

			<v-layout row wrap>
				<v-flex md6 sm6 xs12 :class="{'pa-0': $vuetify.breakpoint.smAndDown, 'pr-2': $vuetify.breakpoint.mdAndUp}">
					<v-toolbar color="#1f97b9" dark>
						<img :src='require("../../../assets/static/img/direccion-o-d.png")' alt="icono de direcciones" style="width: 30px;margin-right:16px;">
						<v-toolbar-title>Dirección Origen</v-toolbar-title>
					</v-toolbar>

					<v-layout ma-3>
						<v-flex md12 sm12 xs12 mx-3>
							<v-text-field
								label="Ingresa calle, número y luego selecciona la sugerencia"
								v-model="datos.direccion_origen.direccion"
								id="starting_address"
								:rules="rules.direccionOrigen"
								placeholder="Sólo Calle y Número"
								v-on:change="datos.direccion_origen.marker = {}"
								required
							></v-text-field>

							<GmapMap
								:center="Object.keys(this.datos.direccion_origen.marker).length > 0 ? this.datos.direccion_origen.marker : {lat: -33.437637, lng: -70.650471}"
								:zoom="15"
								style="width: 100%; height: 200px"
							>
								<GmapMarker
									v-if="Object.keys(this.datos.direccion_origen.marker).length > 0"
									:position="datos.direccion_origen.marker" />
								/>
							</GmapMap>

<!-- 							<v-layout row wrap align-center mt-5>
								<v-flex md6 sm12 xs12 px-3>
									<h3>¿Donde nos estacionamos?</h3>
								</v-flex>
								<v-flex md6 sm12 xs12 px-3>
									<v-select
										label="Estacionamiento"
										v-model="datos.direccion_origen.estacionamiento"
										:items="['Nivel Calle','Subterráneo']"
										append-icon="fas fa-caret-down"
										:rules="rules.nameRules"
										required
									></v-select>
								</v-flex>
							</v-layout> -->

						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex md6 sm6 xs12 :class="{'pa-0': $vuetify.breakpoint.smAndDown, 'pl-2': $vuetify.breakpoint.mdAndUp}">
					<v-toolbar color="#1f97b9" dark>
						<img :src='require("../../../assets/static/img/direccion-o-d.png")' alt="icono de direccion" style="width: 30px;margin-right:16px;">
						<v-toolbar-title>Dirección Destino</v-toolbar-title>
					</v-toolbar>

					<v-layout ma-3>
						<v-flex md12 sm12 xs12 mx-3>
							<v-text-field
								label="Ingresa calle, número y luego selecciona la sugerencia"
								v-model="datos.direccion_destino.direccion"
								id="destination_address"
								:rules="rules.direccionDestino"
								placeholder="Sólo Calle y Número"
								v-on:change="datos.direccion_destino.marker = {}"
								required
							></v-text-field>

							<GmapMap
								:center="Object.keys(this.datos.direccion_destino.marker).length > 0 ? this.datos.direccion_destino.marker : {lat: -33.437637, lng: -70.650471}"
								:zoom="15"
								style="width: 100%; height: 200px"
							>
								<GmapMarker
									v-if="Object.keys(this.datos.direccion_destino.marker).length > 0"
									:position="datos.direccion_destino.marker" />
								/>
							</GmapMap>						

<!-- 							<v-layout row wrap align-center mt-5>
								<v-flex md6 sm12 xs12 px-3>
									<h3>¿Donde nos estacionamos?</h3>
								</v-flex>
								<v-flex md6 sm12 xs12 px-3>
									<v-select
										label="Estacionamiento"
										v-model="datos.direccion_destino.estacionamiento"
										:items="['Nivel Calle','Subterráneo']"
										append-icon="fas fa-caret-down"
										:rules="rules.nameRules"
										required
									></v-select>
								</v-flex>
							</v-layout> -->

						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>

			<v-layout justify-end>
				<v-btn
					color="#1f97b9"
					@click="validate"
					dark
				>
					Siguiente
				</v-btn>
			</v-layout>

		</v-form>


</template>

<script>
	import { EventBus } from '../../../events.js'

	export default {
		name: 'mudanzaFirst',
		data () {
			return {
				datos:{
					personales: {
						nombre: '',
						telefono: '',
						email: ''
					},
					direccion_origen:{
						direccion: "",
						marker: {},
						direccion_obj: {},
						estacionamiento: ''
					},
					direccion_destino:{
						direccion: "",
						marker: {},
						direccion_obj: {},
						estacionamiento: ''
					}
				},
				mantenedores: {},
				modal: false,
				menu2: false,
				modal2: false,
				rules: {
					timeerror: false,
					control: false,
					nameRules: [
						v => !!v || 'Campo obligatorio'
					],
					phoneRules: [
						v => !!v || 'Campo obligatorio'
					],
					emailRules: [
						v => !!v || 'Campo obligatorio',
						v => {
							const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
							if(re.test(v)){
								return true
							}
							return 'Verifica que el email sea válido'
						}
					],
					direccionOrigen: [
						v => !!v || 'Campo obligatorio',
						v => (!!/\d/.test(v) || !this.control) || 'Por favor ingresa también la numeración.',
						v => { 
										if( Object.keys(this.datos.direccion_origen.marker).length > 0 ){
											return true
										}
										else{
											return this.control ? 'Debe seleccionar una dirección sugerida por Google' : true
										}
									}
					],
					direccionDestino: [
						v => !!v || 'Campo obligatorio',
						v => (!!/\d/.test(v) || !this.control) || 'Por favor ingresa también la numeración.',
						v => { 
										if( Object.keys(this.datos.direccion_destino.marker).length > 0 ){
											return true
										}
										else{
											return this.control ? 'Debe seleccionar una dirección sugerida por Google' : true
										}
									}
					]
				},
				currentStep: 0
			}
		},
		methods: {
			validate () {

				this.control = true
				var data = {
					datos: this.datos,
					valid: true
				}
				if(this.$refs.form.validate()){
					EventBus.$emit('fleteFirst', data);
				}
			}
		},
		mounted () {
			const here = this
			EventBus.$on('emmitMantenedores', data => {
				this.mantenedores = data
			})
			EventBus.$on('stepChange', data => {
				this.currentStep = data
			})

			this.$gmapApiPromiseLazy().then(() => {
				let self = this
				let options = {
					componentRestrictions: {country: "cl"}
				}

				//Origen
				let starting_address_input = document.getElementById('starting_address')
				let starting_address_autocomplete = new google.maps.places.Autocomplete(starting_address_input, options)
				starting_address_autocomplete.addListener('place_changed', function() {
					let place = starting_address_autocomplete.getPlace();

					self.datos.direccion_origen.direccion_obj = place
					self.datos.direccion_origen.marker = place.geometry.location
					self.datos.direccion_origen.direccion = place.formatted_address
				})

				//Destino
				let destination_address_input = document.getElementById('destination_address')
				let destination_address_autocomplete = new google.maps.places.Autocomplete(destination_address_input, options)
				destination_address_autocomplete.addListener('place_changed', function() {
					let place = destination_address_autocomplete.getPlace();

					self.datos.direccion_destino.direccion_obj = place
					self.datos.direccion_destino.marker = place.geometry.location
					self.datos.direccion_destino.direccion = place.formatted_address

				})

			})
		}
	}
</script>